module.exports = __webpack_public_path__ + "static/media/26.5ab4bb6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/26.svg
// module id = 141
// module chunks = 0